import { EventEmitter } from '@sm/max-common'

export namespace spa {
  const emitter = new EventEmitter<string>()

  export function clearSubPageCache(route: string) {
    emitter.emit(route)
  }

  export function onClearSubPageCache(handler: (route: string) => void) {
    emitter.event((route) => {
      handler(route)
    })
  }
}
